import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsNumberValueProperty,
  IsStringValueProperty,
} from '@vi-iot/client';
import { DevicesStore, InstallationFeaturesStore, RichDevice } from '@store';
import { filter, map, takeUntil } from 'rxjs/operators';
import { FeaturesDetailsOverlayTypeEnum } from '../../../installation-overlay.model';

@Component({
  selector: 'app-pv-heater-overlay',
  templateUrl: './pv-heater-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PvHeaterOverlayComponent implements OnInit, OnDestroy {
  readonly featurePropertyKey = FeaturePropertyKey;
  readonly availableOverlays = FeaturesDetailsOverlayTypeEnum;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  selectedDeviceId: string;
  gatewaySerial: string;
  inverterModel$: Observable<Feature<IsStringValueProperty, never>>;
  inverterManufacturer$: Observable<Feature<IsStringValueProperty, never>>;
  inverterEtn$: Observable<Feature<IsStringValueProperty, never>>;
  inverterInstalledPeakPower$: Observable<Feature<IsNumberValueProperty, never>>;
  gatewayName$: Observable<string>;
  gatewayEtn$: Observable<Feature<IsStringValueProperty, never>>;
  gatewayFirmware$: Observable<Feature<IsStringValueProperty, never>>;

  constructor(
    private devicesStore: DevicesStore,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.devicesStore.selectedDevice$
      .pipe(
        filter((dev) => Boolean(dev)),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((device) => {
        this.selectedDeviceId = device.id;
        this.getDataForImmersionHeaterOverlay();
      });
  }

  getDataForImmersionHeaterOverlay(): void {
    this.inverterModel$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceThirdpartyModel,
      this.selectedDeviceId
    );
    this.inverterManufacturer$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceThirdpartyManufacturer,
      this.selectedDeviceId
    );
    this.inverterEtn$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceEtn,
      this.selectedDeviceId
    );
    this.gatewayName$ = this.devicesStore.selectedDevice$.pipe(
      filter<RichDevice>(Boolean),
      map((device) => device.marketingName)
    );

    this.devicesStore.getSolarLogGateway$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(({ id }) => {
        this.gatewayEtn$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
          FeatureNames.deviceEtn,
          id
        );
        this.gatewayFirmware$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
          FeatureNames.deviceThirdpartySoftware,
          id
        );
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
